

export default function(){
  // useEffect(()=>{
  //   // console.log('name', moduleHelper.name)
  //   moduleHelper.execute()
  // },[])
  return <div>Demo</div>
}
